import type { InputType } from './types';

export const INPUT_TYPES: { key: InputType; labelKey: string; accept?: string }[] = [
  { key: 'text', labelKey: 'common.text' },
  { key: 'url', labelKey: 'common.url' },
  { key: 'image', labelKey: 'common.image', accept: 'image/jpeg,image/png,image/webp,image/gif' },
  { key: 'audio', labelKey: 'common.audio', accept: 'audio/mpeg,audio/wav,audio/ogg,audio/mp4' },
  { key: 'video', labelKey: 'common.video', accept: 'video/mp4,video/webm,video/ogg' },
];

export const COMPONENT_LABEL_KEYS: Record<string, string> = {
  techniques: 'pipeline.componentNames.techniques',
  ai_tampered: 'pipeline.componentNames.aiTamper',
  claims: 'pipeline.componentNames.claims',
  domain: 'pipeline.componentNames.domain',
  source_assessment: 'pipeline.componentNames.source',
  verdict: 'pipeline.componentNames.verdict',
};

export const COMPONENT_ORDER = ['ai_tampered', 'source_assessment', 'techniques', 'claims'];

export const RISK_COLORS: Record<string, string> = {
  green: '#22c55e',
  lightgreen: '#84cc16',
  yellow: '#eab308',
  orange: '#f97316',
  red: '#ef4444',
  darkred: '#dc2626',
};

export const STATUS_ICON: Record<string, string> = {
  pending: '○',
  running: '◎',
  completed: '●',
  failed: '✗',
  skipped: '—',
};

export const SEVERITY_BG: Record<string, string> = {
  critical: 'rgba(239,68,68,0.10)',
  warning: 'rgba(249,115,22,0.10)',
  info: 'rgba(59,130,246,0.08)',
};
export const SEVERITY_BORDER: Record<string, string> = {
  critical: '#ef4444',
  warning: '#f97316',
  info: '#3b82f6',
};
export const SEVERITY_BG_LIGHT: Record<string, string> = {
  critical: 'rgba(239,68,68,0.06)',
  warning: 'rgba(249,115,22,0.06)',
  info: 'rgba(59,130,246,0.05)',
};

export const formatTechName = (name: string) => {
  const part = name.includes('.') ? name.split('.').pop()! : name;
  return part.replace(/_/g, ' ').replace(/\b\w/g, c => c.toUpperCase());
};

export const formatFactorName = (factor: string) =>
  factor.replace(/_/g, ' ').replace(/\b\w/g, c => c.toUpperCase());

export const getViralityColor = (score: number) =>
  score >= 75 ? '#dc2626' : score >= 50 ? '#ef4444' : score >= 25 ? '#f97316' : '#22c55e';

export const getSeverityColor = (s: number) =>
  s >= 70 ? '#ef4444' : s >= 40 ? '#f97316' : '#eab308';

export const getProbColor = (p: number) =>
  p >= 80 ? '#ef4444' : p >= 60 ? '#f97316' : p >= 40 ? '#eab308' : '#22c55e';

export const getStanceColor = (s: string) =>
  s === 'SUPPORTS' ? '#22c55e' : s === 'CONTRADICTS' ? '#ef4444' : '#94a3b8';

export const getStatusColor = (s: string) => {
  if (s === 'verified_true' || s === 'VT') return '#22c55e';
  if (s === 'verified_false' || s === 'VF_STATUS') return '#ef4444';
  return '#94a3b8';
};

export const safeHostname = (url: string): string => {
  try { return new URL(url).hostname; } catch { return url; }
};
